import { Injectable, inject } from '@angular/core'
import { CaseType, HearingType } from '@ftr/annotations-contracts'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult } from '@ftr/foundation'
import { CaseTypesService } from '../case-types'
import { HearingTypesService } from '../hearing-types'

export interface AnnotationTypes {
  caseTypes: CaseType[]
  hearingTypes: HearingType[]
}

@Injectable({
  providedIn: 'root',
})
export class AnnotationTypesService {
  private caseTypeService = inject(CaseTypesService)
  private hearingTypesService = inject(HearingTypesService)

  /**
   * @param courtSystemId
   * @param audioSegmentId Audio segment id for when annotation types are being requested from outside of a court system
   * @returns Case and Hearings types within a court system. Empty arrays if the feature flag is off
   */
  getAnnotationTypes(courtSystemId: Uuid, audioSegmentId?: Uuid): ApiResult<AnnotationTypes> {
    return ApiResult.combine({
      caseTypes: this.caseTypeService.getCaseTypes(courtSystemId, audioSegmentId),
      hearingTypes: this.hearingTypesService.getHearingTypes(courtSystemId, audioSegmentId),
    })
  }
}
